<script>
	import { user } from "../store.js";
    import Menu from '../components/Menu.svelte';

    export let id = $user.id;
    export let name = $user.name;

    import { QueryClient, QueryClientProvider } from '@sveltestack/svelte-query'
    import ProfilComponent from '../components/ProfileComponent.svelte'
 
    // Create a client
    const queryClient = new QueryClient()
</script>

<Menu />

<QueryClientProvider client={queryClient}>
    <ProfilComponent {id} {name} />
</QueryClientProvider>